export default {
  'smile': '😄',
  'smiley': '😃',
  'grinning': '😀',
  'blush': '😊',
  'wink': '😉',
  'heart_eyes': '😍',
  'kissing_heart': '😘',
  'pensive': '😔',
  'relieved': '😌',
  'unamused': '😒',
  'disappointed': '😞',
  'persevere': '😣',
  'cry': '😢',
  'joy': '😂',
  'sob': '😭',
  'scream': '😱',
  'angry': '😠',
  'rage': '😡',
  'triumph': '😤',
  'confounded': '😖',
  'laughing': '😆',
  'yum': '😋',
  'mask': '😷',
  'thumbs_up': '👍'
} 